import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

interface SyncrosBrandIconProps extends IconWrapperProps {
  variant?: "light" | "dark";
}

function SyncrosBrandSvg(props: {
  variant?: "light" | "dark";
  className?: string;
}) {
  const variant = props.variant || "light";
  const fillColor = variant === "light" ? "currentColor" : "#44403C";

  return (
    <svg
      className={props.className}
      fill="none"
      role="img"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Syncros</title>
      <mask
        height="35"
        id="mask0_5103_29816"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="36"
        x="6"
        y="7"
      >
        <path d="M42 7H6V41.0935H42V7Z" fill="white" />
      </mask>
      <g mask="url(#mask0_5103_29816)">
        <mask
          height="35"
          id="mask1_5103_29816"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="36"
          x="6"
          y="7"
        >
          <path d="M42 7H6V41.0935H42V7Z" fill="white" />
        </mask>
        <g mask="url(#mask1_5103_29816)">
          <path
            d="M30.493 10.9611C27.0338 10.1828 11.9409 7 11.9409 7L6 17.9238V32.6861C6 32.6861 13.359 19.0967 14.4682 17.1134C15.7192 14.885 17.4108 14.0106 19.4316 14.0106H35.2285C33.1469 12.1127 32.4631 11.409 30.4879 10.9611"
            fill={fillColor}
          />
          <path
            d="M17.5082 37.1312C20.9674 37.9096 36.0602 41.0924 36.0602 41.0924L42.0011 30.1686V15.4062C42.0011 15.4062 34.6421 28.9957 33.5278 30.9789C32.2769 33.2074 30.5852 34.0817 28.5644 34.0817H12.7676C14.8492 35.9797 15.5329 36.6834 17.5082 37.1312Z"
            fill={fillColor}
          />
          <path
            d="M31.8698 20.1039C31.176 21.3941 27.418 28.3568 26.8558 29.4017C26.3797 30.2867 25.8327 30.6919 24.445 30.6919H17.6785C15.4095 30.6919 15.3842 28.8952 15.7843 28.1008C16.2958 27.0826 20.5502 19.3895 20.9047 18.7018C21.4061 17.7315 22.4697 17.3477 23.3611 17.3477H29.4236C31.3735 17.3477 32.5637 18.7978 31.8648 20.1039"
            fill={fillColor}
          />
        </g>
      </g>
    </svg>
  );
}

export function IconSyncrosBrand(props: SyncrosBrandIconProps) {
  return (
    <IconWrapper {...props}>
      <SyncrosBrandSvg className={props.className} variant={props.variant} />
    </IconWrapper>
  );
}
